import { render, staticRenderFns } from "./ArticleDiscountGroup.vue?vue&type=template&id=dbdc3194&scoped=true"
import script from "./ArticleDiscountGroup.vue?vue&type=script&lang=js"
export * from "./ArticleDiscountGroup.vue?vue&type=script&lang=js"
import style0 from "./ArticleDiscountGroup.vue?vue&type=style&index=0&id=dbdc3194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc3194",
  null
  
)

export default component.exports